import { IFeature } from 'mod/featureV2/interface';

const video = {
    bgColor: '#666',
    src: 'file-asset/file/6a850710f4ee9020a478fa0caff005dc.mp4',
    backup: 'file-asset/file/62205f7a09e5dc4661cdcd6640e32305/1703665032125/output.m3u8',
    poster: 'asset/width-3840/picture/eba58330bfafdde773c90779dd8973e1.png',
};

export const banner: IFeature = {
    type: 'banner',
    moduleId: 'banner',
    title: 'banner',
    description: 'description',
    config: {
        width: 3840,
        height: 1860,
        column: 3,
        spaceBetweenColumns: 20,
        bgColor: '#c9d9ce',
    },
    list: [
        {
            src: 'asset/width-3840/picture/eba58330bfafdde773c90779dd8973e1.png',
            alt: 'test',
            href: '/vivosun-smart-grow-box?mock=1',
        },
        {
            src: 'asset/width-3840/picture/eba58330bfafdde773c90779dd8973e1.png',
            large: 'asset/width-3840/picture/fd86506cd62c23660cc6118d045e00af.jpg',
            alt: 'test',
            href: '/vivosun-smart-grow-box?mock=1',
        },
        {
            ...video,
            href: '/vivosun-smart-grow-box?mock=1',
            loop: true,
        },
        {
            ...video,
            autoPlay: true,
            loop: true,
        },
        {
            ...video,
            autoPlay: false,
            control: true,
            loop: false,
        },
        {
            ...video,
            autoPlay: false,
            control: {
                size: 40,
                opacity: 0.6
            },
            loop: false,
        },
        {
            ...video,
            autoPlay: true,
            controls: true,
        },
        {
            ...video,
            autoPlay: false,
            controls: true,
        },
    ]
};

export const bannerLarge: IFeature= {
    type: 'banner',
    moduleId: 'bannerLarge',
    title: 'large screen banner',
    config: {
        width: 3840,
        height: 1860,
        column: 1,
        fullScreen: true,
        largeScreenHeightFixed: true,
        bgColor: '#c9d9ce',
    },
    list: [
        {
            src: 'asset/width-3840/picture/eba58330bfafdde773c90779dd8973e1.png',
            large: 'asset/width-3840/picture/fd86506cd62c23660cc6118d045e00af.jpg',
            alt: 'test',
            href: '/vivosun-smart-grow-box?mock=1',
        },
    ]
}